import UserLogsDisplay from './UserLogsDisplay';
import useUserLogs from './useUserLogs';

export default function UserLogsScreen() {
  const {
    traces,
    fetchTraceLogs,
    fetchTraces,
    isLoading,
    sliceTraces,
    cursor,
    canGoNext,
    canGoPrev,
  } = useUserLogs();
  return (
    <UserLogsDisplay
      traces={traces}
      cursor={cursor}
      fetchTraceLogs={fetchTraceLogs}
      fetchTraces={fetchTraces}
      isLoading={isLoading}
      sliceTraces={sliceTraces}
      canGoNext={canGoNext}
      canGoPrev={canGoPrev}
    />
  );
}
